import api from "@modules/api/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { LocalDate } from "@js-joda/core";
import consumerFinancingQueryKeys from "../consumerFinancingQueryKeys";

type PostBody = {
  /** from form inputs */
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  dateOfBirth: LocalDate;
  suiteNumber: string | null;
  streetNumber: string | null;
  streetName: string | null;
  city: string;
  province: string;
  postalCode: string;
  vehiclePrice: number;
  annualIncome: number;
  totalMonthlyDebts: number;
  isConsentGiven: boolean;

  /** from query params */
  odometer: number;
  year?: number | null;
  make?: string | null;
  model?: string | null;
  trim?: string | null;
  vin?: string | null;
  source?: string | null;
  vehicleCoverImage?: string | null;
  sourceAdId?: string | null;
  sourceAppId?: string | null;
  sourceLocationId?: string | null;
  sourceSessionId?: string | null;
  sourceUserId?: string | null;
  sourceCtaId?: string | null;
};

export type CreateConsumerFinancingPreQualificationResponse = {
  id: string;
};

const postCreateConsumerFinancingPreQualification = async (req: PostBody) => {
  return api.post<CreateConsumerFinancingPreQualificationResponse>(
    `api/purchases/c2c-financing/consumer-financing-pre-qualification`,
    {
      json: req,
    }
  );
};

export default function useCreateConsumerFinancingPreQualificationMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postCreateConsumerFinancingPreQualification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: consumerFinancingQueryKeys.consumerFinancing(),
      });
    },
  });
}
